<template>
	<div>
		<CommonHeader :setOrden="true" :showMenu="true" :showBackButton="true" :title="$t('EnlazarRedes')"></CommonHeader>
		<div class="content">
			<p>Enlazar redes sociales</p>
			<Google :title="$t('ConectarGoogle')"></Google>
			<!-- <Facebook :title="$t('ConectarGoogle')"></Facebook> -->
		</div>
	</div>
</template>
<script>
import { Component, Vue } from 'vue-property-decorator'
import CommonHeader from '@/components/CommonHeader.vue'
import Google from '@/components/ButtonGoogle.vue'
import Facebook from '@/components/ButtonFacebook.vue'
@Component({
	components: {
		CommonHeader,
		Google,
		Facebook,
	},
})
export default class ChangePassword extends Vue {}
</script>
<style  lang="scss" scoped>
.content {
	padding: 0em 1em;
	p {
		color: rgba(254, 202, 56, 1);
		font-weight: 700;
		font-size: 1.8em;
        margin: 1em 0 ;
	}
    button{
        margin: 1em 0 0 ;
    }
}
</style>
